<template>
  <div>
    <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Administração - Dashboard'"
      :titulo="'dashboard'"
    />
    <div class="dashboard-admin">
      <div class="card-container">
        <div class="card-menu">
          <i class="bi bi-tools"></i>
          <a href="/admin/cortesias" class="nav-link"> Cortesias </a>
        </div>
        <div class="card-menu">
          <i class="bi bi-people-fill"></i>
          <a href="/admin/clientes" class="nav-link"> Clientes </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-building"></i>
          <a href="/admin/empresas" class="nav-link"> Empresas </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-megaphone"></i>
          <a href="/admin/midias" class="nav-link"> Mídias </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-person-badge"></i>
          <a href="/admin/usuarios" class="nav-link"> Usuários </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-bank2"></i>
          <a href="/admin/bancos" class="nav-link"> Bancos </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-graph-up"></i>
          <a href="/admin/custos_variaveis" class="nav-link">
            Custos Variáveis
          </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-percent"></i>
          <a href="/admin/taxas" class="nav-link"> Taxas </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-fuel-pump"></i>
          <a href="/admin/combustiveis" class="nav-link"> Combustíveis </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-palette"></i>
          <a href="/admin/cor_veiculos" class="nav-link"> Cor Veículo </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-car-front-fill"></i>
          <a href="/admin/familia_veiculos" class="nav-link">
            Família Veículos
          </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-tag-fill"></i>
          <a href="/admin/marca_veiculos" class="nav-link"> Marca Veículos </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-card-checklist"></i>
          <a href="/admin/modelo_veiculos" class="nav-link">
            Modelo Veículos
          </a>
        </div>

        <div class="card-menu">
          <i class="bi bi-arrow-repeat"></i>
          <a href="/admin/estoque_veiculos" class="nav-link">
            Sincronizar Estoque
          </a>
        </div>
      </div>
    </div>
    <Rodape />
  </div>
</template>

<script>
import UserService from "../services/user.service";
//import EventBus from "../common/EventBus";
import SidebarVue from "./menu/Sidebar.vue";
import Rodape from "./menu/Rodape.vue";
import Navgator from "./menu/Navgator.vue";

export default {
  components: {
    SidebarVue,
    Navgator,
    Rodape
  },
  data() {
    return {
      content: ""
    };
  },
  computed: {
    currentTheme() {
      return this.$store.getters.currentTheme;
    }
  },
  mounted() {
    UserService.getAdminBoard().then(
      (response) => {
        this.content = response.data;
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        console.log("Erro de login", error);
        if (error.response && error.response.status === 403) {
          console.log("Entrei no IF");
          this.$store.dispatch("auth/logout");
          this.$router.push("/login");
        }
      }
    );
  }
};
</script>
